import React from 'react';
import {
  NavLink,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { useTranslation } from 'react-i18next';
import { Hidden } from '@material-ui/core';

// style
// import { globalStyle } from '../../global/style';
import './style.scss';
import '../../global/styles.scss';
import './styles.css';
import { styles } from './style';

// images
import Th from '../../assets/fag/th.png';
import En from '../../assets/fag/en.png';
import TargetBlankIcon from '../../assets/icons/open_in_new.png';

const initPath = `/${process.env.REACT_APP_PATH}`;

const useStyles = makeStyles(styles);

export default function Header() {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const currentTH = i18n.language === 'th';
  const currentEN = i18n.language === 'en';

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <Box>
        <NavLink to={`${initPath}`} className="navbar-item" exact>
          {t('ภาพรวมประเทศไทย')}
        </NavLink>
        <NavLink to={`${initPath}reportwater/events`} className="navbar-item">
          {t('บันทึกเหตุการณ์น้ำ')}
        </NavLink>
        <NavLink to={`${initPath}floodday`} className="navbar-item">
          {t('พื้นที่น้ำท่วมจากดาวเทียม GISTDA')}
        </NavLink>
        <a href="https://waterchart.thaiwater.net/" className="navbar-item" target="_blank" rel="noopener noreferrer">
          {t('แผนที่ผังน้ำประเทศไทย')}
        </a>
        <NavLink to={`${initPath}intro`} className="navbar-item">
          {t('แนะนำการใช้งาน')}
        </NavLink>
        <NavLink to={`${initPath}about`} className="navbar-item">
          {t('เกี่ยวกับเรา')}
        </NavLink>
        <NavLink to={`${initPath}contact`} className="navbar-item">
          {t('ติดต่อเรา')}
        </NavLink>
      </Box>
      <Divider />
      <Box>
        <a href="https://supermap.onwr.go.th/" className="navbar-item" target="_blank" rel="noopener noreferrer">
          <Box sx={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          }}
          >
            {t('ระบบแผนที่ข้อมูลทรัพยากรน้ำ')}
            <img src={TargetBlankIcon} alt="TargetBlankIcon" height={14} width={14} style={{ marginRight: 5 }} />
          </Box>
        </a>
      </Box>
      <Hidden mdUp>
        <Box mt={2}>
          <Typography noWrap variant="caption">
            {t('เปลี่ยนภาษา')}
          </Typography>
          {currentTH && (
            <MenuItem style={{ paddingLeft: 0 }} onClick={() => changeLanguage('en')}>
              <ListItemIcon>
                <img src={En} alt="En" />
              </ListItemIcon>
              <Typography className={classes.lang} noWrap>
                En
              </Typography>
            </MenuItem>
          )}

          {currentEN && (
            <MenuItem style={{ paddingLeft: 0 }} onClick={() => changeLanguage('th')}>
              <ListItemIcon>
                <img src={Th} alt="Th" />
              </ListItemIcon>
              <Typography className={classes.lang} noWrap>
                ไทย
              </Typography>
            </MenuItem>
          )}
        </Box>
      </Hidden>
    </>
  );
}
